import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';
import { NekoIcon } from '../misc/Icon';

const LinkContainer = Styled.div`
  display: flex;
  align-items: center;
`;

const Link = Styled.span`
  color: ${props => props.variant || Theme.blue};
  cursor: pointer;
  font-family: ${Theme.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  &.is-active {
    cursor: default;
    color: ${Theme.black};
    font-weight: bold;
  }

  &::after {
    content: "|";
    color: ${Theme.darkGray};
    padding: 0 4px;
  }

  &:last-child::after {
    content: none;
  }

  span {
    color: ${Theme.darkGray};
    font-weight: normal;
    margin-left: 4px;
  }
`;

const StyledNekoQuickLinks = props => {
  const { id, value, onChange, busy = false, className } = props;

  const children = React.Children.toArray(props.children).filter(v => !!v).map(child => {
    return React.cloneElement(child, {
      busy: busy,
      isActive: child.props.value === value,
      onClick: (newValue) => {
        if (newValue !== value) {
          onChange(newValue, id);
        }
      }
    });
  });

  return (
    <LinkContainer className={className}>{children}</LinkContainer>
  );
};

const StyledNekoLink = props => {
  const { title, value = 0, count, onClick, busy, isActive, className, variant } = props;

  const variantValue = useMemo(() => {
    if (!variant) return undefined
    return Object.keys(Theme).includes(variant) ? Theme[variant] : variant
  }, [variant])

  return (
    <Link onClick={() => onClick(value)} className={`${isActive ? 'is-active' : ''} ${className}`} variant={variantValue}>
      {title}
      {count === undefined ? null :
        <span>(
          {busy ? 
            <NekoIcon icon="replay" spinning={true} width={12} containerStyle={{ display: 'inline' }} /> : 
            count
          })
        </span>
      }
    </Link>
  );
};

const NekoQuickLinks = (props) => {
  return (<StyledNekoQuickLinks {...props} />);
};

NekoQuickLinks.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
};

NekoQuickLinks.defaultProps = {
  id: undefined,
  value: undefined,
  onChange: undefined
};

const NekoLink = (props) => {
  return (<StyledNekoLink {...props} />);
};

NekoLink.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  count: PropTypes.number,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
  variant: PropTypes.string,
};

NekoLink.defaultProps = {
  title: undefined,
  value: 'default',
  count: undefined,
  onClick: undefined,
  isActive: false,
  variant: undefined,
};

export { NekoQuickLinks, NekoLink };
